import React, { useState, useRef } from 'react'
import { Modal, Form, Button, InputGroup, } from 'react-bootstrap'
import useToken from '../App/useToken'
import axios from 'axios'

export default function AddFeedbackDialogPopup({selectedItem, show, setShow}) {
    const { token, getCustomer } = useToken()
    const formRef = useRef(null)
    const topics = ['Feedback','Bug','Feature request', 'Other']
    const subTopics = ['Portal', 'Drone', 'App', 'Data', 'Other']

    const [validated, setValidated] = useState(false)
    const [topic, setTopic] = useState('Feedback')
    const [subTopic, setSubTopic] = useState('Portal')
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [charCount, setCharCount] = useState(0);
    const [importance, setImportance] = useState(5); 
    const [errorMsg, setErrorMsg] = useState('')
    const handleDescriptionChange = (event) => {
        const text = event.target.value;
        if (text.length <= 200) {
        setDescription(text);
        setCharCount(text.length);
        }
    };
    const handleImportanceChange = (event) => {
        setImportance(event.target.value);
      };
    const handleSubmit = (e) => {
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
        } else {
            
            const data = {
                'token': token,
                'feedback': {
                    'topic': topic,
                    'subTopic': subTopic,
                    'title': title,
                    'description': description,
                    'importance': importance,
                    'customerId': getCustomer()?.customerId
                }
            }
            var config = {
                method: 'post',
                url: "api/insert_new_feedback",
                data: data
            };
            axios(config).then(response => {
                // // console.log(response.data)
            }).catch(error => {
                setErrorMsg(error)
                // // console.log('error', error)
            })
            e.preventDefault();
            e.stopPropagation();
        }
        // // console.log(event)
        setValidated(true)   
    }
    return (
        <Modal
        show={show}
        onHide={() => setShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        >
        <div style={{backgroundColor: "#212529", color: "#ffffff"}}>
        <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
            Select topics and describe yor issue with our services.
            <p style={{marginBottom:"0", fontSize:'small', color:'orange'}}> *Disclaimer*</p>
            <p style={{fontSize:'small', color:'orange'}}>We cannot promise when or if your issue will be fixed, but we appriciate your feedback and it will help us to improve our services.</p> 
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form ref={formRef} noValidate validated={validated} onSubmit={(e) => handleSubmit(e)}>
            <Form.Group md="4" controlId="validationCustomDrone">
                <Form.Label>Select topic</Form.Label>
                <InputGroup hasValidation>
                    <Form.Select onChange={(e)=> setTopic(e.target.value)} defaultValue='Feedback' aria-label="topic select">
                        {
                            topics.map(item => {
                                    return <option value={item}>{item}</option>
                                })
                        }
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                    Please select a topic
                    </Form.Control.Feedback>
                </InputGroup>
            </Form.Group>
            <Form.Group md="4" controlId="validationCustomDrone">
            <Form.Label>Select category</Form.Label>
            <InputGroup hasValidation>
                <Form.Select onChange={(e)=> setSubTopic(e.target.value)} defaultValue='Portal' aria-label="category select">
                    {
                        subTopics.map(item => {
                                return <option value={item}>{item}</option>
                            })
                    }
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                Please select a category
                </Form.Control.Feedback>
            </InputGroup>
            </Form.Group>
            <Form.Group md="4" controlId="title">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Title"
                            defaultValue=""
                            onChange={(e) => setTitle(e.target.value)}
                        />
            </Form.Group>
            <Form.Group controlId="description">
                <Form.Label>Description</Form.Label>
                <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Enter description (max 200 characters)"
                    value={description}
                    onChange={handleDescriptionChange}
                />
                <small className="text-muted">{charCount}/200 characters</small>
            </Form.Group>
            <Form.Group controlId="importance" className="mt-3">
                <Form.Label>Importance (1-10)</Form.Label>
                    <Form.Control
                        type="range"
                        min="1"
                        max="10"
                        color='#a2c520'
                        value={importance}
                        onChange={handleImportanceChange}
                    />
                    <p>Selected Importance: <strong>{importance}</strong></p>
            </Form.Group>
            <Button className='df-button' type="submit">Submit form</Button>
            </Form>
            <aside>         
            <p style={{color: 'orangered'}}>{errorMsg}</p>
            </aside>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={() => setShow(false)}>Cancel</Button>
        </Modal.Footer>
        </div>
        </Modal>
    );
}
